/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';


Blockly.Blocks.BHOOT_motor_single = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/30.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('PIN1')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_TURN_RIGHT, '3'],
        [Blockly.Msg.LANG_MOTOR_TURN_LEFT, '4'],
        [Blockly.Msg.LANG_MOTOR_TURN_BRAKE, '6'],
      ]), 'DIR');

    this.appendDummyInput('PIN1')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_SINGLE_PIN)
      .appendField(new Blockly.FieldDropdown(
        function () {
          return Blockly.getMainWorkspace().getHardwarePinsCombo('motorPwm', `${this.component}_NPIN`)
        },
      ), 'NPIN');

    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_SINGLE_TOOLTIP);
  },
  component: 'motor',
  getPins: () => ['NPIN'],
};

// NPIN/NPIN2 guardan un par de pines "3,2" que el generador parte por coma; no
// renombrar los campos o los proyectos guardados no deserializan. Los inputs
// dummy se numeran distinto al legacy porque v13 exige nombres únicos.

Blockly.Blocks.SALIDAS_motor = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/02.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_TURN_RIGHT || 'Girar a la derecha', '3'],
        [Blockly.Msg.LANG_MOTOR_TURN_LEFT || 'Girar a la izquierda', '4'],
        [Blockly.Msg.LANG_MOTOR_TURN_BRAKE || 'Frenar', '6'],
      ]), 'NPIN1');
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('ultrasonic', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'motordc',
};

Blockly.Blocks.SALIDAS_motor_doble = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/022.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_DOUBLE_FORWARD || 'Mover hacia adelante', '3'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_BACKWARD || 'Mover hacia atrás', '4'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_RIGHT || 'Girar a la derecha', '5'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_LEFT || 'Girar a la izquierda', '6'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_BRAKE || 'Frenar', '7'],
      ]), 'NPIN1');
    this.appendDummyInput('PIND')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PIND)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('ultrasonic', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendDummyInput('PINI')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PINI)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('ultrasonic', `${this.component}_NPIN2`),
      ), 'NPIN2');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_TOOLTIP);
  },
  getPins: function () { return ['NPIN', 'NPIN2']; },
  component: 'motor',
};

Blockly.Blocks.SALIDAS_motor_doble_pwm = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/022.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('DIR')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_DOUBLE_FORWARD || 'Mover hacia adelante', '3'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_BACKWARD || 'Mover hacia atrás', '4'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_RIGHT || 'Girar a la derecha', '5'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_LEFT || 'Girar a la izquierda', '6'],
        [Blockly.Msg.LANG_MOTOR_DOUBLE_BRAKE || 'Frenar', '7'],
      ]), 'NPIN1');
    this.appendDummyInput('PIND')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_PIND)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('motorPwm', `${this.component}_NPIN`),
      ), 'NPIN');
    this.appendDummyInput('PINI')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_PINI)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('motorPwm', `${this.component}_NPIN2`),
      ), 'NPIN2');
    this.appendDummyInput('SPEED')
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_SPEED);
    this.appendValueInput('DATOIN')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_DOBLE_PWM_TOOLTIP);
  },
  getPins: function () { return ['NPIN', 'NPIN2']; },
  component: 'motor',
};

// servo_read usa setOutput(true, 'Boolean') como string: en v13 el constructor
// no funciona como check.

Blockly.Blocks.servo_move = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/14.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MOVE_DEGREES);
    this.appendValueInput('angulo')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('PIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MOVE)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_SERVO_MOVE_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo',
};

Blockly.Blocks.servo_read = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/14.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_SERVO_READ)
      .appendField(Blockly.Msg.LANG_SERVO_READ_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true, 'Boolean');
    this.setTooltip(Blockly.Msg.LANG_SERVO_CONT_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'servo',
};